/* KIS sokkenkaart: bundel- en maat-pop-up + toevoegen aan winkelwagen (live assets/kis-socks-card.js 2026-10-02,
   1-op-1 op Dawn). Kaart = snippets/kis-socks-card.liquid. Bundelkeuze 1/2/3 packs met dezelfde korting als de
   sokken-productpagina (automatische kortingen "Bundle 2/3 (Sokken)": 16% / 17%; percentages uit data-kis-socks
   "tiers"). Eén luisteraar op document, zodat het ook werkt na het herladen van het raster door facets.js.
   Verschil met live: na het toevoegen wordt Dawn's cart drawer ververst en geopend (sections in de add-respons,
   cart-drawer.renderContents) en wordt cart-update gepubliceerd via pubsub.js, zoals Dawn's product-form.js.
   Productdata: uit data-kis-socks (sectie-productveld) of, bij data-kis-socks-fetch, uit /products/<handle>.js. */
(function () {
  if (window.KIS_SOCKS_INIT) return;
  window.KIS_SOCKS_INIT = true;

  var modal = null;
  var lastTrigger = null;
  var state = { data: null, tier: 2, sizes: [], busy: false };
  var fetched = {};

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }
  function calc(n) {
    var pct = (state.data.tiers && state.data.tiers[n - 1]) || 0;
    var full = state.data.cents * n;
    var save = Math.round(full * pct / 100);
    return { full: full, save: save, total: full - save, pct: pct };
  }

  /* Productdata ophalen als de sectie geen product heeft gekozen (geen all_products) */
  function readData(card) {
    try { return JSON.parse(card.getAttribute('data-kis-socks')); } catch (err) { return null; }
  }
  function writeData(card, data) {
    card.setAttribute('data-kis-socks', JSON.stringify(data));
  }
  function hydrate(card) {
    var handle = card.getAttribute('data-kis-socks-fetch');
    if (!handle) return Promise.resolve(readData(card));
    if (!fetched[handle]) {
      fetched[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); })
        .catch(function () { return null; });
    }
    return fetched[handle].then(function (p) {
      var data = readData(card) || {};
      var item = card.closest('.kis-socks-item');
      if (!p || !p.available) {
        if (item) item.hidden = true;
        return null;
      }
      data.cents = p.price;
      data.price = money(p.price);
      data.available = true;
      data.url = p.url || data.url;
      data.variants = (p.variants || []).map(function (v) { return { id: v.id, title: v.title, available: !!v.available }; });
      if (!data.img && p.featured_image) data.img = p.featured_image;
      writeData(card, data);
      card.removeAttribute('data-kis-socks-fetch');
      var price = card.querySelector('[data-kis-socks-price]');
      if (price && !price.textContent.trim()) price.textContent = data.price;
      return data;
    });
  }
  function hydrateAll() {
    document.querySelectorAll('[data-kis-socks-fetch]').forEach(function (card) { hydrate(card); });
  }

  function build() {
    modal = document.createElement('div');
    modal.className = 'kis-size-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'kis-size-modal-title');
    modal.innerHTML =
      '<div class="kis-size-modal__panel">' +
      '<div class="kis-size-modal__top">' +
      '<div class="kis-size-modal__thumb"><img alt="" data-kis-thumb></div>' +
      '<div><div class="kis-size-modal__name" id="kis-size-modal-title" data-kis-name></div>' +
      '<div class="kis-size-modal__price" data-kis-price></div></div>' +
      '<button type="button" class="kis-size-modal__close" aria-label="Sluiten" data-kis-close>&times;</button>' +
      '</div>' +
      '<p class="kis-size-modal__label">Kies je bundel</p>' +
      '<div class="kis-size-modal__tiers" role="radiogroup" aria-label="Bundel" data-kis-tiers></div>' +
      '<p class="kis-size-modal__label">Kies je maat</p>' +
      '<div class="kis-size-modal__packs" data-kis-packs></div>' +
      '<button type="button" class="kis-size-modal__atc" aria-disabled="true" data-kis-atc>Toevoegen aan winkelwagen</button>' +
      '<p class="kis-size-modal__msg" role="status" data-kis-msg></p>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-kis-close]')) { close(); return; }
      var t = e.target.closest('[data-kis-tier]');
      if (t) { setTier(Number(t.getAttribute('data-kis-tier'))); return; }
      var s = e.target.closest('[data-kis-size]');
      if (s && !s.disabled) { pickSize(Number(s.getAttribute('data-kis-pack')), s.getAttribute('data-kis-size')); return; }
      if (e.target.closest('[data-kis-atc]')) add();
    });

    document.addEventListener('keydown', function (e) {
      if (!modal || !modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var f = modal.querySelectorAll('button:not([disabled])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  function renderTiers() {
    var labels = ['', 'Populair', 'Beste deal'];
    var html = '';
    for (var n = 1; n <= 3; n++) {
      var c = calc(n);
      var active = n === state.tier;
      html += '<button type="button" class="kis-size-modal__tier' + (active ? ' is-active' : '') + '" role="radio" aria-checked="' + active + '" data-kis-tier="' + n + '">' +
        (labels[n - 1] ? '<span class="kis-size-modal__tag' + (n === 3 ? ' kis-size-modal__tag--best' : '') + '">' + labels[n - 1] + '</span>' : '') +
        '<span class="kis-size-modal__tier-main"><b>' + n + ' ' + (n === 1 ? 'pack' : 'packs') + '</b>' +
        '<small>' + (c.save > 0 ? 'Bespaar ' + money(c.save) : 'Geen bundelkorting') + '</small></span>' +
        '<span class="kis-size-modal__tier-price"><b>' + money(c.total) + '</b>' + (c.save > 0 ? '<s>' + money(c.full) + '</s>' : '') + '</span>' +
        '</button>';
    }
    modal.querySelector('[data-kis-tiers]').innerHTML = html;
  }

  function renderPacks() {
    var html = '';
    for (var i = 0; i < state.tier; i++) {
      html += '<div class="kis-size-modal__pack">' +
        (state.tier > 1 ? '<span class="kis-size-modal__pack-label">Pack ' + (i + 1) + '</span>' : '') +
        '<div class="kis-size-modal__sizes" role="group" aria-label="Maat pack ' + (i + 1) + '">';
      (state.data.variants || []).forEach(function (v) {
        var on = String(state.sizes[i]) === String(v.id);
        html += '<button type="button" class="kis-size-modal__size' + (on ? ' is-active' : '') + '" aria-pressed="' + on + '" data-kis-pack="' + i + '" data-kis-size="' + esc(v.id) + '"' +
          (v.available ? '' : ' disabled aria-label="' + esc(v.title) + ' uitverkocht"') + '>' + esc(v.title) + '</button>';
      });
      html += '</div></div>';
    }
    modal.querySelector('[data-kis-packs]').innerHTML = html;
  }

  function renderSummary() {
    var c = calc(state.tier);
    modal.querySelector('[data-kis-price]').innerHTML = money(c.total) + (c.save > 0 ? ' <s>' + money(c.full) + '</s>' : '');
    var ready = state.sizes.slice(0, state.tier).filter(Boolean).length === state.tier;
    modal.querySelector('[data-kis-atc]').setAttribute('aria-disabled', ready ? 'false' : 'true');
    modal.querySelector('[data-kis-atc]').textContent = 'Toevoegen aan winkelwagen · ' + money(c.total);
  }

  function setTier(n) {
    state.tier = n;
    var firstSize = state.sizes.filter(Boolean)[0];
    for (var i = 0; i < n; i++) if (!state.sizes[i] && firstSize) state.sizes[i] = firstSize;
    renderTiers();
    renderPacks();
    renderSummary();
    modal.querySelector('[data-kis-msg]').textContent = '';
  }

  function pickSize(pack, id) {
    var wasEmpty = !state.sizes.filter(Boolean).length;
    state.sizes[pack] = id;
    if (wasEmpty) {
      for (var i = 0; i < state.tier; i++) if (!state.sizes[i]) state.sizes[i] = id;
    }
    renderPacks();
    renderSummary();
    modal.querySelector('[data-kis-msg]').textContent = '';
  }

  function open(card, trigger) {
    hydrate(card).then(function (data) {
      if (!data || !data.variants || !data.variants.length) {
        if (data && data.url) window.location.href = data.url;
        return;
      }
      if (!modal) build();
      lastTrigger = trigger || null;
      state.data = data;
      state.tier = Number(data.defaultTier) || 2;
      state.sizes = [];
      modal.querySelector('[data-kis-thumb]').src = data.img || '';
      modal.querySelector('[data-kis-name]').textContent = data.title || '';
      modal.querySelector('[data-kis-msg]').textContent = '';
      renderTiers();
      renderPacks();
      renderSummary();
      modal.classList.add('is-open');
      document.documentElement.classList.add('kis-modal-open');
      var active = modal.querySelector('[data-kis-tier].is-active');
      (active || modal.querySelector('[data-kis-close]')).focus();
    });
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('kis-modal-open');
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
  }

  /* Dawn: winkelwagen-lade (of melding) verversen en openen, zoals product-form.js */
  function cartElement() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function add() {
    var msg = modal.querySelector('[data-kis-msg]');
    var atc = modal.querySelector('[data-kis-atc]');
    var chosen = state.sizes.slice(0, state.tier);
    if (chosen.filter(Boolean).length < state.tier) {
      msg.textContent = state.tier > 1 ? 'Kies een maat voor elke pack.' : 'Kies eerst je maat.';
      return;
    }
    if (state.busy) return;
    state.busy = true;
    atc.textContent = 'Bezig met toevoegen...';

    var qty = {};
    chosen.forEach(function (id) { qty[id] = (qty[id] || 0) + 1; });
    var items = Object.keys(qty).map(function (id) { return { id: Number(id), quantity: qty[id] }; });

    var cart = cartElement();
    var body = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    if (addUrl.indexOf('.js') === -1) addUrl += '.js';

    fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (response) {
        close();
        var published = null;
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            published = publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kis-socks-card', productVariantId: items[0].id, cartData: response });
          }
        } catch (err) {}
        var finish = function () {
          if (/\/cart(\/|$|\?)/.test(location.pathname)) {
            location.reload();
          } else if (cart && typeof cart.renderContents === 'function' && response && response.sections) {
            cart.renderContents(response);
          } else if (cart && typeof cart.open === 'function') {
            cart.open(lastTrigger);
          } else {
            location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        };
        if (published && typeof published.then === 'function') published.then(finish, finish);
        else finish();
      })
      .catch(function () {
        msg.textContent = 'Toevoegen lukte niet, probeer het opnieuw.';
      })
      .then(function () {
        state.busy = false;
        if (modal.classList.contains('is-open')) renderSummary();
      });
  }

  /* Capture-fase: op de collectiepagina stopt een ander script de bubbling van klikken op knoppen */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-kis-socks-open]');
    if (!trigger) return;
    var card = trigger.closest('[data-kis-socks]');
    if (!card) return;
    e.preventDefault();
    e.stopPropagation();
    open(card, trigger);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrateAll);
  else hydrateAll();
  var grid = document.getElementById('ProductGridContainer');
  if (grid && 'MutationObserver' in window) {
    new MutationObserver(function () { hydrateAll(); }).observe(grid, { childList: true });
  }
})();
